<template>
    <diagram :class="css.diagram" :option="option" :empty="$t('NoData')" :data="data">
        <template #operate="{ data }">
            <ui-button :class="[css.button, css.extra]" size="small" @click="view(data)">{{ $t("ViewFile") }}</ui-button>
            <ui-button :class="[css.button]" size="small" @click="Systems.download(data.href)">{{ $t("OpenFile") }}</ui-button>
        </template>
    </diagram>
</template>

<script lang="ts" setup>
//* 组件库
import { UiButton } from "various-ui";
//* 公共组件
import { Diagram } from "@/components/visualizations";
import type { DiagramsOption } from "@/components/visualizations/diagrams/default";
//* 公共函数
import { Systems } from "@/assets/js";
//* 样式
import css from "./index.module.less";

//* 插件
const i18n = useI18n();

//* 数据源
const data = [
    {
        number: 1,
        suffix: "PDB",
        size: "317.53KB",
        name: "2JEL.pdb",
        href: "https://rdgta.cdn.cyagen.com/rddc/data/2JEL.pdb",
    },
    {
        number: 2,
        suffix: "PDB",
        size: "1.4MB",
        name: "stability_1l0n.pdb",
        href: "https://rdgta.cdn.cyagen.com/rddc/data/stability_1l0n.pdb",
    },
    {
        number: 3,
        suffix: "PDB",
        size: "462.27KB",
        name: "input.pdb",
        href: "https://rdgta.cdn.cyagen.com/rddc/data/input.pdb",
    },
    {
        number: 4,
        suffix: "PDB",
        size: "488.93KB",
        name: "dg_2ypv.pdb",
        href: "https://rdgta.cdn.cyagen.com/rddc/data/dg_2ypv.pdb",
    },
    {
        number: 5,
        suffix: "PDB",
        size: "162.49KB",
        name: "1PPF.pdb",
        href: "https://rdgta.cdn.cyagen.com/rddc/data/1PPF.pdb",
    },
];

//* 图表配置项
const option = <DiagramsOption[]>[
    { key: "number", name: i18n.t("SerialNumber"), width: 120 },
    { key: "name", name: i18n.t("FileName"), width: 320 },
    { key: "size", name: i18n.t("FileSize"), width: 120 },
    { key: "suffix", name: i18n.t("Suffix"), width: 120 },
    { key: "operate", name: i18n.t("Operate"), width: 180 },
];

const view = (data: any) => window.open("/tool/pdb/abview/?url=" + data.href, "_blank");
</script>
